<template>
  <div class="exam-info-page" v-loading="loadingData">
    <div class="exam-info-card">
      <div class="title">考试信息</div>
      <div class="content-wrapper">
        <div class="info-list">
          <div class="row">
            <div class="label">考试名称</div>
            <div class="value">{{ examInfo.name }}</div>
          </div>
          <div class="row">
            <div class="label">考试专业</div>
            <div class="value">{{ examInfo.majorName }}</div>
          </div>
          <div class="row">
            <div class="label">题目数量</div>
            <div class="value">{{ examInfo.questionNum }}题</div>
          </div>
          <div class="row">
            <div class="label">考试时间</div>
            <div class="value">{{ examInfo.formalTestDuration }}分钟</div>
          </div>
          <div class="row">
            <div class="label">分数占比</div>
            <div class="value">{{ formalTestScoreProportionDisplay }}%</div>
          </div>
        </div>

        <div class="tips-section">
          <div class="tips-title">
            <span class="icon">i</span>
            <span class="tt">注意事项</span>
          </div>
          <div class="tips-content">
            <p>
              1、点击“提交答卷”，判断题目是否全部答完；如果没答完，提示“题目未答完，确认要交卷吗？”；如果已经答完，提示“确认要提交答卷吗？”。
            </p>
            <p>2、确定交卷后，进入考试结果界面。</p>
            <p>
              3、答题时点击返回按钮提示“您还没有提交答卷，确定需要退出吗，退出后自动提交答卷，本次考试机会将扣除”。
            </p>
          </div>
        </div>

        <div class="action-section">
          <button
            class="start-btn"
            :class="{ 'disabled-btn': examEntryDisabled }"
            :disabled="examEntryDisabled"
            @click="go2FormalExamPage"
          >
            {{ examEntryText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      examInfo: {
        examEndTime: "2000-01-01 00:00:00",
        examStartTime: "2000-01-01 00:00:00",
        formalTestDuration: 60, // 分钟
        learnScoreProportion: "50.0",
        name: "暂无考试",
        majorName: "暂无专业",
        questionNum: 0,
        testAttention: "暂无信息"
      },
      loadingData: true,
      examLeftDays: -2, // 距离考试的天数，-2：错误信息，-1：已结束，0：进行中；>0：实际天数
      currentErId: null,
      examAttemptsExhausted: false
    };
  },
  computed: {
    formalTestScoreProportionDisplay() {
      const learnRatio = Number(this.examInfo.learnScoreProportion);
      if (!Number.isFinite(learnRatio)) {
        return "100";
      }
      const value = Math.max(0, Math.min(100, 100 - learnRatio));
      if (Number.isInteger(value)) {
        return String(value);
      }
      return value
        .toFixed(2)
        .replace(/0+$/, "")
        .replace(/\.$/, "");
    },
    examEntryDisabled() {
      return this.examLeftDays !== 0 || this.examAttemptsExhausted;
    },
    examEntryText() {
      if (this.examAttemptsExhausted) {
        return "考试已结束";
      }
      if (this.examLeftDays === -2) {
        return "暂无考试";
      }
      if (this.examLeftDays === -1) {
        return "考试已结束";
      }
      if (this.examLeftDays > 0) {
        return "考试未开始";
      }
      return "开始考试";
    }
  },
  created: function() {
    this.currentErId = this.$route.query.erId
      ? Number(this.$route.query.erId)
      : null;
    // 加载信息，确认
    this.loadExamInfo();
  },
  methods: {
    calcExamLeftDaysByExam(exam) {
      if (!exam || !exam.examStartTime || !exam.examEndTime) {
        this.examLeftDays = -2;
        return;
      }
      const now = new Date();
      const examStartTime = new Date(
        String(exam.examStartTime).replace(/-/g, "/")
      );
      this.examLeftDays = Math.ceil((examStartTime - now) / (1000 * 3600 * 24));
      if (this.examLeftDays < 0) {
        const examEndTime = new Date(
          String(exam.examEndTime).replace(/-/g, "/")
        );
        const examEndLeftDays = Math.ceil(
          (examEndTime - now) / (1000 * 3600 * 24)
        );
        this.examLeftDays = examEndLeftDays < 0 ? -1 : 0;
      }
    },
    fillExamInfoByExam(exam) {
      this.examInfo.majorName = exam.major
        ? exam.major.name
        : this.examInfo.majorName;
      this.examInfo.examStartTime =
        exam.examStartTime || this.examInfo.examStartTime;
      this.examInfo.examEndTime = exam.examEndTime || this.examInfo.examEndTime;
      this.examInfo.name = exam.name || this.examInfo.name;
    },
    updateExamAttemptStateByApply(apply) {
      const examCount = Number(apply && apply.examCount);
      this.examAttemptsExhausted = Number.isFinite(examCount) && examCount >= 2;
    },
    async loadExamInfo() {
      if (this.currentErId) {
        const detailRes = await httpRequest("/app/exam/exam/info", "get", {
          erId: this.currentErId
        });
        if (detailRes && detailRes.code === 200 && detailRes.data) {
          const exam = detailRes.data;
          this.updateExamAttemptStateByApply(exam.apply);
          this.calcExamLeftDaysByExam(exam);
          this.fillExamInfoByExam(exam);
        }

        const noticeRes = await httpRequest("/app/formal-test/notice", "get", {
          erId: this.currentErId
        });
        if (noticeRes && noticeRes.code === 200 && noticeRes.data) {
          this.examInfo = noticeRes.data;
        }
        this.loadingData = false;
        return;
      }

      // 先加载考试信息，判断用户是否合法进入该地址
      let res = await httpRequest("/app/exam/exam", "get", null);
      if (res !== null && res !== undefined && res.code === 200) {
        const examFullInfo = res.data;
        if (examFullInfo.apply !== null && examFullInfo.apply !== undefined) {
          this.updateExamAttemptStateByApply(examFullInfo.apply);
          const fallbackErId = Number(
            (examFullInfo.apply && examFullInfo.apply.erId) ||
              (examFullInfo.exam && examFullInfo.exam.erId)
          );
          if (Number.isFinite(fallbackErId) && fallbackErId > 0) {
            this.currentErId = fallbackErId;
          }
          // 计算距离考试还有多久
          const now = new Date();
          const examStartTime = new Date(examFullInfo.exam.examStartTime);
          this.examLeftDays = Math.ceil(
            (examStartTime - now) / (1000 * 3600 * 24)
          );
          if (this.examLeftDays < 0) {
            // 已经开始考试了，判断是否已经结束了
            const examEndTime = new Date(examFullInfo.exam.examEndTime);
            const examEndLeftDays = Math.ceil(
              (examEndTime - now) / (1000 * 3600 * 24)
            );
            if (examEndLeftDays < 0) {
              this.examLeftDays = -1; // 表示已经结束了
            } else {
              this.examLeftDays = 0; // 表示进行中
            }
          }

          const noticeParams = this.currentErId
            ? { erId: this.currentErId }
            : null;
          res = await httpRequest(
            "/app/formal-test/notice",
            "get",
            noticeParams
          );
          if (res !== null && res !== undefined && res.code === 200) {
            this.examInfo = res.data;
          }
        }
      }
      this.loadingData = false;
    },
    getFormalExamRouteQuery() {
      const erId = Number(this.currentErId);
      if (!Number.isFinite(erId) || erId <= 0) {
        return null;
      }
      return {
        erId: String(erId)
      };
    },
    go2FormalExamPage() {
      if (this.examAttemptsExhausted) {
        this.$message.warning("考试已结束");
        return;
      }
      const query = this.getFormalExamRouteQuery();
      if (!query) {
        this.$router.push({ path: "/formalExam" });
        return;
      }
      this.$router.push({
        path: "/formalExam",
        query
      });
    }
  }
};
</script>

<style scoped lang="scss">
.exam-info-page {
  width: 100%;
  min-height: calc(100vh - 67px);
  background: #f0f2f5;
  padding: 40px 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.exam-info-card {
  width: 1200px;
  max-width: 95%;
  background: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  overflow: hidden;

  .title {
    height: 60px;
    line-height: 60px;
    background: #4095e5;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
    letter-spacing: 1px;
  }

  .content-wrapper {
    padding: 60px 80px 80px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .info-list {
    max-width: 100%;
    position: relative;
    padding-bottom: 20px;

    .row {
      display: flex;
      margin-bottom: 10px;
      line-height: 28px;
      font-size: 18px;
      font-family: PingFang-SC-Medium, PingFang-SC;

      .label {
        width: 120px;
        color: #333333;
        font-weight: 500;
        text-align: left;
      }

      .value {
        flex: 1;
        color: #1ab8c5;
        font-weight: 500;
        padding-left: 20px;
        text-align: left;
      }
    }
  }

  .tips-section {
    width: 100%;
    position: relative;
    padding-top: 30px;
    border-top: 1px dashed #e8ecef;

    .tips-title {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      font-size: 16px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: #767676;

      .icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: #1ab8c5;
        color: #ffffff;
        font-size: 12px;
        font-weight: bold;
        margin-right: 6px;
      }

      .tt {
        line-height: 1;
      }
    }

    .tips-content {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #333333;
      line-height: 2.2;
      text-align: left;

      p {
        margin: 0;
      }
    }
  }

  .action-section {
    margin-top: 80px;
    width: 100%;
    display: flex;
    justify-content: center;

    .start-btn {
      width: 280px;
      height: 48px;
      border: none;
      border-radius: 4px;
      background: #0f68c4;
      color: #ffffff;
      font-size: 17px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      cursor: pointer;
      transition: background-color 0.2s, opacity 0.2s;
      letter-spacing: 1px;

      &:hover:not(:disabled) {
        background: #1275db;
      }

      &:active:not(:disabled) {
        background: #0c57a3;
      }

      &.disabled-btn {
        background: #cccccc;
        color: #ffffff;
        cursor: not-allowed;
      }
    }
  }
}
</style>
